import React from 'react';
import Icon from '../../../components/AppIcon';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      icon: 'ClipboardList',
      title: 'Answer 25 Questions',
      description: 'Respond honestly. No right answers. Just patterns.'
    },
    {
      number: '02',
      icon: 'BarChart3',
      title: 'Instant Analysis',
      description: 'Algorithm identifies your dominant False Self pattern'
    },
    {
      number: '03',
      icon: 'Mail',
      title: 'Get Results',
      description: 'Personalized report reveals the mechanism behind your behavior'
    },
    {
      number: '04',
      icon: 'Lightbulb',
      title: 'Install New Patterns',
      description: 'Specific strategies to dissolve the False Self and build infrastructure'
    }
  ];

  return (
    <div className="w-full bg-brand-black py-16 md:py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-white mb-4 uppercase tracking-tight">
            How It Works
          </h2>
          <p className="text-lg md:text-xl text-brand-steel max-w-2xl mx-auto">
            Four steps to identify the survival identity sabotaging your growth
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {steps?.map((step, index) => (
            <div 
              key={index}
              className="relative bg-brand-charcoal rounded-lg p-8 border border-brand-slate hover:border-brand-gold transition-all duration-250"
            >
              {/* Step Number Badge */}
              <div className="absolute -top-4 -left-4 w-14 h-14 rounded-md bg-brand-gold text-brand-black font-bold text-xl flex items-center justify-center">
                {step?.number}
              </div>

              <div className="flex items-start gap-4 mt-2">
                <div className="w-12 h-12 rounded-md bg-brand-gold/10 flex items-center justify-center flex-shrink-0">
                  <Icon 
                    name={step?.icon} 
                    size={24} 
                    color="#C9A227"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-brand-white text-lg mb-2 uppercase tracking-wide">
                    {step?.title}
                  </h3>
                  <p className="text-base text-brand-steel leading-relaxed">
                    {step?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Time Estimate */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-4 bg-brand-charcoal rounded-lg border border-brand-slate">
            <Icon name="Clock" size={20} color="#C9A227" />
            <span className="text-base font-semibold text-brand-white uppercase tracking-wide">
              2 minutes to complete
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;